<ion-header class="ion-no-border">
    <ion-toolbar>
        <ion-buttons slot="end" class="ion-align-items-start">
            <ion-button color="dark" (click)="close()">
                <ion-icon slot="icon-only" color="dark" name="close-circle-outline"></ion-icon>
            </ion-button>
        </ion-buttons>

        <ion-grid class="title-container">
            <ion-row>
                <ion-col class="ion-text-center">
                    <span class="title-header">{{ itemName }}</span>
                    <span *ngIf="!!flavorText" class="description">{{ flavorText }}</span>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-toolbar>
</ion-header>

<ion-content fullscreen>
    <ion-grid class="information-row">
        <ion-row *ngIf="!parentOrderItem">
            <ion-col>
                <div class="image-container" [class.terminal-image]="terminalMode">
                    <bb-menu-item-image [menuItem]="menuItem"
                                        [orderDisplay]="true"></bb-menu-item-image>
                </div>
            </ion-col>
            <ion-col *ngIf="!miscItem" class="ion-text-center information-container-cell">
                <div class="information-container">
                    <div *ngIf="!!orderItem && (orderTotal() > 0 || orderItem.selectedPrice.tokenPrice > 0) && orderDeposits() === 0"
                         class="price-container">
                        <div *ngIf="orderItem.selectedPrice.tokenPrice > 0; else nonTokenPrice">
                            <span>{{ orderTokensTotal() }}</span>
                            <ion-icon src="assets/icon/token.svg" class="default-token-price-icon"></ion-icon>
                        </div>
                        <ng-template #nonTokenPrice>
                            <span class="default-price">{{ orderTotal() | currency }}</span>
                        </ng-template>
                    </div>
                    <ng-container *ngIf="!!orderItem && orderDeposits() > 0">
                        <div class="itemized-price-container">
                            <div class="itemized-price-container-child">
                                <div class="itemized-price-row">
                                    <span class="itemized-price-label">Item</span>
                                    <span class="itemized-price">{{ orderTotal() | currency }}</span>
                                </div>
                                <div class="itemized-price-row">
                                    <ion-text class="itemized-price-label" color="tertiary">Deposit</ion-text>
                                    <ion-text class="itemized-price" color="tertiary">{{ orderDeposits() | currency }}</ion-text>
                                </div>
                                <div class="itemized-price-row">
                                    <span class="itemized-price-label">Total</span>
                                    <span class="itemized-price">{{ paymentTotal() | currency }}</span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ion-chip *ngIf="!parentOrderItem" color="dark" [outline]="true">
                        <ion-icon name="remove-outline" (click)="remove()" class="order-count-icon"></ion-icon>
                        <ion-label class="order-count-label">{{ orderItem.count }}</ion-label>
                        <ion-icon name="add-outline" (click)="add()" class="order-count-icon"></ion-icon>
                    </ion-chip>
                </div>
            </ion-col>
        </ion-row>
        <ion-row *ngIf="!miscItem">
            <ion-col>
                <bb-order-type-selection *ngIf="!!orderItem"
                                         [orderType]="orderItem.orderType"
                                         [hideInHouse]="hideInHouse"
                                         [hideTogo]="hideTogo"
                                         (orderTypeChange)="orderTypeChange($event)"></bb-order-type-selection>
            </ion-col>
        </ion-row>
    </ion-grid>
    <ng-container *ngIf="miscItem">
        <ion-grid [formGroup]="formGroup">
            <ion-row>
                <ion-col>
                    <ion-item>
                        <ion-label position="floating">Amount</ion-label>
                        <ion-input inputmode="numeric" formControlName="amount" bbCurrencyMask #amount></ion-input>
                    </ion-item>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <ion-item>
                        <ion-label position="floating">Reason:</ion-label>
                        <ion-textarea rows="5" formControlName="reason"></ion-textarea>
                    </ion-item>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ng-container>
    <ion-grid *ngIf="!miscItem">
        <ion-row *ngIf="!!menuItem.description && !parentOrderItem">
            <ion-col class="ion-padding">
                <span class="description item-description">
                {{ menuItem.description }}
                </span>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col
                    *ngIf="!parentSelection && !!prices && (prices.length > 1 || (prices.length === 1 && prices[0].name !== 'Default')) && !orderItem.menuSelectionItem"
                    size-xs="12" size-md="6">
                <ion-list>
                    <ion-radio-group [(ngModel)]="orderItem.selectedPrice" (ionChange)="recalculateToppingPrices()">
                        <ion-list-header *ngIf="!!menuItem.priceLabel && menuItem.priceLabel.length > 0">
                            <ion-label>{{ menuItem.priceLabel }}</ion-label>
                        </ion-list-header>
                        <ion-item *ngFor="let price of prices; trackBy: getId;"
                                  [disabled]="!terminalMode && !!price.menuItemInventory && price.menuItemInventory.currentCount < 1">
                            <ion-label>
                                <div class="menu-item-price-container">
                                    <span class="price-name">{{ !!price.name ? price.name : '' }}</span>
                                    <span class="price-price">
                                        <ng-container *ngIf="!!price.tokenPrice">
                                            <bb-tokens [count]="price.tokenPrice"></bb-tokens>
                                        </ng-container>
                                        <span *ngIf="!price.tokenPrice">
                                            {{ price.price | currency }}
                                        </span>
                                    </span>
                                </div>
                            </ion-label>
                            <ion-radio slot="start" [value]="price" color="success"></ion-radio>

                            <ion-button *ngIf="terminalMode && !!price.menuItemInventory" slot="end" color="dark"
                                        (click)="adjustInventory($event, price.menuItemInventory)">
                                {{ price.menuItemInventory.currentCount > 0 ? price.menuItemInventory.currentCount : 'Sold Out' }}
                            </ion-button>

                            <ion-badge *ngIf="!terminalMode && !!price.menuItemInventory && price.menuItemInventory.currentCount < 1"
                                       class="inventory-badge"
                                       color="dark"
                                       slot="end">
                                Sold Out
                            </ion-badge>
                        </ion-item>
                    </ion-radio-group>
                </ion-list>
            </ion-col>

            <ion-col *ngIf="orderItem.selectedPrice.variable" [formGroup]="formGroup" size-xs="12" size-md="6">
                <ion-item>
                    <ion-label position="floating">Amount</ion-label>
                    <ion-input inputmode="numeric" formControlName="amount" bbCurrencyMask (ionChange)="updateTotal()" #amount></ion-input>
                </ion-item>
            </ion-col>
            <ion-col *ngIf="containsModifiers" size-xs="12" size-md="6">
                <bb-order-modifier [modifiers]="orderItem.modifiers"
                                   [modifiersDefinition]="menuItem"
                                   [modifiedItem]="orderItem"
                                   [sizeXs]="12"
                                   [sizeSm]="12"
                                   [sizeMd]="12"
                                   [sizeLg]="12"
                                   [sizeXl]="12"
                                   (modifiersChange)="modifiersChange($event)">
                </bb-order-modifier>
            </ion-col>

            <ion-col *ngFor="let selection of prioritySelections; trackBy: getId;" size-xs="12" size-md="6">
                <bb-display-order-item-selection [orderItem]="orderItem"
                                                 [menuItem]="menuItem"
                                                 [terminalMode]="terminalMode"
                                                 [selection]="selection">
                </bb-display-order-item-selection>
            </ion-col>

            <ng-container *ngIf="orderItem.includedToppings.length > 0 || orderItem.optionalToppings.length > 0">
                <ion-col *ngIf="orderItem.includedToppings.length > 0" size-xs="12" size-md="6">
                    <ion-item [button]="true" [detail]="false" (click)="openToppingsModal = true" lines="none">
                        <ion-label>
                            <span class="title">Included Toppings</span>
                            <ng-container *ngFor="let topping of orderItem.includedToppings">
                                <p *ngIf="!topping.included" class="selection-summary">Remove {{ topping.menuItemTopping.name }}</p>
                            </ng-container>
                        </ion-label>
                    </ion-item>
                    <bb-display-order-item-topping *ngFor="let orderItemTopping of orderItem.includedToppings"
                                                   [orderItemTopping]="orderItemTopping"
                                                   (remove)="removeTopping(orderItemTopping)">
                    </bb-display-order-item-topping>
                </ion-col>

                <ion-col *ngIf="orderItem.optionalToppings.length > 0" size-xs="12" size-md="6">
                    <ion-item [button]="true" [detail]="false" (click)="openToppingsModal = true" lines="none">
                        <ion-label>
                            <span class="title">Optional Toppings</span>
                            <p *ngIf="menuItem.freeOptionalToppingCount > 0 || menuItem.maxOptionalToppingCount > 0"
                               class="selection-summary">
                                {{ menuItem.freeOptionalToppingCount }} Free Optional Topping{{
                                    menuItem.freeOptionalToppingCount > 1
                                        ? 's'
                                        : ''
                                }}
                            </p>
                        </ion-label>
                    </ion-item>
                    <ion-item *ngIf="!orderItem.containsOptionalToppings"
                              [button]="true" [detail]="false"
                              (click)="openToppingsModal = true">
                        <ion-label>None</ion-label>
                    </ion-item>
                    <bb-display-order-item-topping *ngFor="let orderItemTopping of orderItem.optionalToppings"
                                                   [orderItemTopping]="orderItemTopping"
                                                   [optional]="true"
                                                   (remove)="removeTopping(orderItemTopping)">
                    </bb-display-order-item-topping>
                </ion-col>
            </ng-container>

            <ion-col *ngFor="let selection of nonPrioritySelections; trackBy: getId;" size-xs="12" size-md="6">
                <bb-display-order-item-selection [orderItem]="orderItem"
                                                 [menuItem]="menuItem"
                                                 [terminalMode]="terminalMode"
                                                 [selection]="selection">
                </bb-display-order-item-selection>
            </ion-col>
        </ion-row>
        <ion-row *ngIf="!!organization.allowOrderNotes">
            <ion-col size-xs="12">
                <ion-item>
                    <ion-label position="floating">Instructions:</ion-label>
                    <ion-textarea rows="5" [maxlength]="500" [(ngModel)]="orderItem.notes"></ion-textarea>
                </ion-item>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>

<ion-footer class="ion-no-border">
    <ion-button *ngIf="!terminalMode && (!pickupLocation || pickupLocation.status !== 'ACTIVE')" color="dark" class="footer-button" [disabled]="true">
        Not Taking Online Orders
    </ion-button>
    <ion-button *ngIf="terminalMode || (!!pickupLocation && pickupLocation.status === 'ACTIVE')"
                [disabled]="(!miscItem && !orderItem.selectedPrice) || (miscItem && formGroup.invalid) || !validModifiers"
                color="dark"
                class="footer-button"
                (click)="confirmSubmit()">
        {{ !editMode ? 'Add to' : 'Update' }} Order
    </ion-button>
</ion-footer>

<ion-modal *ngIf="openToppingsModal"
           [isOpen]="openToppingsModal"
           css-class="menu-modal"
           (didDismiss)="openToppingsModal = false">
    <ng-template>
        <modal-header title="Toppings"></modal-header>
        <ion-content class="ion-padding">
            <ion-grid>
                <ng-container *ngIf="!!orderItem.includedToppings && orderItem.includedToppings.length > 0">
                    <ion-row>
                        <ion-item lines="none">
                            <ion-label><span class="title">Included Toppings</span></ion-label>
                        </ion-item>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-grid>
                                <ion-row>
                                    <ion-col *ngFor="let orderItemTopping of orderItem.includedToppings" size-xs="12" size-md="6" size-xl="4">
                                        <ion-item [lines]="orderItemTopping.containsModifiers ? 'none' : null">
                                            <ion-label>{{ orderItemTopping.menuItemTopping.topping.name }}</ion-label>
                                            <ion-checkbox slot="start" [(ngModel)]="orderItemTopping.included"
                                                          (ionChange)="resetTopping(orderItemTopping)"></ion-checkbox>
                                            <span slot="end"
                                                  *ngIf="orderItemTopping.computedPrice">{{ orderItemTopping.computedPrice | currency }}</span>
                                        </ion-item>
                                    </ion-col>
                                </ion-row>
                            </ion-grid>
                        </ion-col>
                    </ion-row>
                </ng-container>
                <ng-container *ngIf="!!orderItem.optionalToppings && orderItem.optionalToppings.length > 0">
                    <ion-row>
                        <ion-item lines="none">
                            <ion-label><span class="title">Optional Toppings</span></ion-label>
                        </ion-item>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-radio-group multiple (ionChange)="distributeOptionalToppingPrices()">
                                <ion-grid>
                                    <ion-row>
                                        <ion-col *ngFor="let orderItemTopping of orderItem.optionalToppings" size-xs="12" size-md="6" size-xl="4">
                                            <ion-item
                                                    [lines]="orderItemTopping.included && orderItemTopping.containsModifiers ? 'none' : null">
                                                <ion-label>{{ orderItemTopping.menuItemTopping.topping.name }}</ion-label>
                                                <ion-checkbox slot="start" [(ngModel)]="orderItemTopping.included"
                                                              (ionChange)="resetTopping(orderItemTopping)"></ion-checkbox>
                                                <span slot="end"
                                                      *ngIf="!nextOptionalToppingFree && (orderItemTopping.included ? orderItemTopping.additionalPrice : orderItemTopping.computedPrice)">
                                                    {{
                                                        (orderItemTopping.included
                                                            ? orderItemTopping.additionalPrice
                                                            : orderItemTopping.computedPrice) | currency
                                                    }}
                                                </span>
                                            </ion-item>
                                        </ion-col>
                                    </ion-row>
                                </ion-grid>
                            </ion-radio-group>
                        </ion-col>
                    </ion-row>
                </ng-container>
            </ion-grid>
        </ion-content>
        <ion-footer class="ion-no-border">
            <ion-button color="dark" class="footer-button" (click)="openToppingsModal = false">
                Done
            </ion-button>
        </ion-footer>
    </ng-template>
</ion-modal>
